<template>
  <div class="card" v-show="currentCardId == cardId">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ title }}</h2>
        <p>{{ description }}</p>
        <div class="add-item" v-if="showExamples">
          <el-button
            style="background-color: #004d40; border-color: #004d40"
            type="success"
            @click="dialogVisible = true"
            >例文から追加</el-button
          >
        </div>
      </div>
      <div class="card-content">
        <LetterExampleSentenceDialog
          v-if="showExamples"
          :value="dialogVisible"
          :name="dialogName"
          :items="filteredItems"
          @input="dialogVisible = $event"
          @select="onSelect"
        />
        <el-input
          type="textarea"
          v-model="fieldValue"
          :autosize="{ minRows: 5, maxRows: 15 }"
        />
        <div class="attention-limit character" v-if="previewErrors[errorKey]">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くしてください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'
import LetterExampleSentenceDialog, {
  type LetterExampleSentenceItem
} from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'

type TextareaField = 'taishokureason' | 'entrySummary' | 'resumeSummary'

const props = withDefaults(
  defineProps<{
    currentCardId?: string
    cardId: string
    title: string
    description: string
    fieldKey: TextareaField
    errorKey: string
    showExamples?: boolean
    dialogName?: string
    sentences?: LetterExampleSentenceItem[]
    previewErrors: Record<string, string | undefined>
  }>(),
  {
    showExamples: false,
    dialogName: '',
    sentences: () => []
  }
)

const formatData = useTaishokutodokeFormatData()
const dialogVisible = ref(false)

const fieldValue = computed({
  get() {
    const value = formatData[props.fieldKey]
    return typeof value === 'string' ? value : ''
  },
  set(next: string) {
    formatData[props.fieldKey] = next
  }
})

const filteredItems = computed(() => {
  const selectedOccupation = formatData.occupation
  return (props.sentences || []).filter(
    (item) => item.type === selectedOccupation
  )
})

function onSelect(sentences: string) {
  formatData[props.fieldKey] = sentences
}
</script>
